import { State } from 'src/replicant/State';
import { hasJoinedLeague } from 'src/replicant/match2/leagues/leagues.getters';
import { getPersistent } from 'src/replicant/stats/stats.getters';
import { getSession } from './stats.getters';

/**
 * Get puzzle attempts analytics stats
 */
export function getPuzzleAttemptsStats(state: State) {
  // Ignore if player is in the master league
  if (hasJoinedLeague(state)) {
    return {};
  }

  return {
    sessionSequence: getSession('puzzleAttempts', 1),
    absoluteSequence: getPersistent(state, 'puzzleAttempts', 1),
    sessionLevelSequence: getSession('currentPuzzleAttempts', 1),
    absoluteLevelSequence: getPersistent(state, 'currentPuzzleAttempts', 1),
  };
}
